<ng-container [ngSwitch]="mode">
  <ng-container
    *ngSwitchCase="LabelMode.DEFAULT"
    [ngTemplateOutlet]="default"
  ></ng-container>
  <ng-container
    *ngSwitchCase="LabelMode.INLINE"
    [ngTemplateOutlet]="inline"
  ></ng-container>
  <ng-container
    *ngSwitchCase="LabelMode.NO_LABEL"
    [ngTemplateOutlet]="input"
  ></ng-container>
</ng-container>

<ng-template #input>
  <ng-select
    [id]="name"
    class="{{ inputClass }}"
    [ngClass]="{ error: isError }"
    [formControl]="form"
    [items]="options$ | async"
    bindLabel="{{ bindLabel }}"
    bindValue="{{ bindValue }}"
    [placeholder]="placeholder | translate"
    [loading]="isLoading"
    [clearable]="clearable"
    [searchable]="searchable"
    [typeahead]="search$"
    [multiple]="multiple"
    [appendTo]="appendTo"
  >
    <ng-template *ngIf="badge" ng-option-tmp let-item="item">
      <div class="custom-option">
        <span [ngClass]="item.class">{{ item.name }}</span>
      </div>
    </ng-template>
    <ng-template *ngIf="badge" ng-label-tmp let-item="item">
      <span [ngClass]="item.class">{{ item.name }}</span>
    </ng-template>
  </ng-select>
  <span class="error" *ngIf="isError">{{ errorMessage | translate }}</span>
</ng-template>

<ng-template #default>
  <div class="form-group" [ngClass]="classes">
    <label
      [for]="name"
      class="col-form-label fw-bold fs-6 py-2"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}
      <span
        *ngIf="addonLabel && addonLabel != '*'"
        class="{{ addonLabelClass }}"
        >({{ addonLabel | translate }})</span
      >
      <span
        *ngIf="addonLabel && addonLabel === '*'"
        class="{{ addonLabelClass }}"
        >{{ addonLabel | translate }}</span
      >
    </label>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline" [ngClass]="classes">
    <label
      [for]="name"
      class="col-form-label fw-bold fs-6 py-2"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}</label
    >
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>
